import { render, staticRenderFns } from "./InvoiceItemDimensionView.vue?vue&type=template&id=4358387b&scoped=true&"
import script from "./InvoiceItemDimensionView.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemDimensionView.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemDimensionView.vue?vue&type=style&index=0&id=4358387b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358387b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VIcon,VSimpleTable,VTooltip})
